/**
 * Convert a string to a URL-friendly slug
 * Handles German umlauts and special characters
 */
export function slugify(text) {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    // Replace German umlauts
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    // Replace spaces and special chars with hyphens
    .replace(/\s+/g, '-')
    // Remove non-word characters except hyphens
    .replace(/[^\w\-]+/g, '')
    // Replace multiple hyphens with single hyphen
    .replace(/\-\-+/g, '-')
    // Trim hyphens from start and end
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

/**
 * Generate artwork URL path
 */
export function getArtworkPath(artwork, language = 'de') {
  if (!artwork) return '/';
  
  const slug = slugify(artwork.title?.de || artwork.title?.en || '');
  const prefix = language === 'de' ? 'werk' : 'artwork';
  
  return `/${prefix}/${slug}`;
}

/**
 * Parse artwork slug from URL path
 * Returns { prefix, slug } or null if not an artwork path
 */
export function parseArtworkPath(path) {
  if (!path) return null;
  
  const match = path.match(/^\/(werk|artwork)\/(.+)$/);
  if (match) {
    return {
      prefix: match[1],
      slug: match[2],
      language: match[1] === 'werk' ? 'de' : 'en'
    };
  }
  
  return null;
}

/**
 * Find artwork by slug in artworks array
 */
export function findArtworkBySlug(artworks, slug) {
  if (!artworks || !slug) return null;
  
  return artworks.find(artwork => {
    const deSlug = slugify(artwork.title?.de);
    const enSlug = slugify(artwork.title?.en);
    return deSlug === slug || enSlug === slug;
  });
}
